<template>
  <main>
    <PageHeaderUI
      title="Booking Confirmed"
      breadcrumb="Dashboard > Operations > Shipments"
    />
    <div class="h-8 w-full bg-white"></div>
    <div class="p-3">
      <div class="h-10 w-full flex justify-end">
        <!-- <button
        @click="doorToDoorShow = !doorToDoorShow"
        class="h-6 w-6 rounded-full border-red-500 text-red-500 border-2 flex justify-center items-center">&#x2715;</button> -->
      </div>
      <BookingDirection v-if="doorToDoorShow" :aboutToExit="aboutToExit"/>
    </div>
  </main>
</template>

<script>
import BookingDirection from "@/components/Ondemand/Bookings/BookingDirection.vue";
import PageHeaderUI from "@/components/Ondemand/UI/PageHeaderUI.vue";

export default {
  components: {
    BookingDirection,
    PageHeaderUI,
  },
  data() {
    return {
      doorToDoorShow: true,
      aboutToExit: false
    };
  },
  sockets: {
    connect: function() {
      console.log("socket to notification channel connected");
    },
  },
  beforeDestroy() {
    this.aboutToExit = true
    this.sockets.unsubscribe(localStorage.getItem('bookinDirectionTripId'));
    this.sockets.unsubscribe(localStorage.getItem('bookinDirectionShippingId'));
    this.sockets.unsubscribe('trip_driver');

    localStorage.removeItem('bookinDirectionTripId')
    localStorage.removeItem('bookinDirectionShippingId')
  },
  beforeRouteLeave(to, from, next) {
    // Call your actions here
    this.$store.dispatch("saveLatestNewBookinTabNum", 1);
    this.$store.dispatch("saveResetNewBookingState");
    // Call next() to proceed with the navigation
    next();
  },
};
</script>

<style></style>
